/**
 * AppFooter — Wraps GlobalFooter for Gamin ENGINE.
 *
 * Newsletter signup is rendered here too — keeps the brand pattern consistent
 * with the marketing website and gamin-plus. Replace the stub submit handler
 * with the real newsletter client when the service endpoint lands.
 */

import { GlobalFooter } from '@engagexp/legendary-ui-primitives';
import {
  footerColumns,
  socialLinks,
  footerLegalLinks,
  footerLegalText,
} from '~/config/nav';

export function AppFooter() {
  return (
    <GlobalFooter
      logo={{
        src: 'https://placehold.co/140x32/121212/3bd80d?text=Gamin+ENGINE',
        alt: 'Gamin ENGINE',
        href: '/',
      }}
      newsletter={{
        heading: 'Stay ahead of the meta',
        description:
          'Weekly drops on tournament features, prize-pool insights, and ENGINE updates.',
        inputPlaceholder: 'you@engagexp.gg',
        buttonLabel: 'Subscribe',
      }}
      onNewsletterSubmit={async (_email) => {
        // TODO: wire to real newsletter client.
        await Promise.resolve();
        return { ok: true as const };
      }}
      columns={footerColumns}
      socialLinks={socialLinks}
      legalText={footerLegalText}
      legalLinks={footerLegalLinks}
    />
  );
}

AppFooter.displayName = 'AppFooter';
